import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import {
  convertConstantLiteralToNormal,
  getCustomerDisplayName,
} from "../../utils/string.helpers";
import {
  HasLatLong,
  TripResponse,
  TripStopLabelStruct,
  TripStopResponse,
  VehicleStopResponse,
  VehicleTripResponse,
} from "types/trip.types";
import { OrderResponse } from "types/order.types";
import { DefaultMantineColor } from "@mantine/core";

dayjs.extend(utc);
dayjs.extend(timezone);

export type ActionFunc = (action: string, params?: any) => any;

export function stopToDndItem(
  trip: TripResponse,
  stop: TripStopResponse,
  tripIndex: number,
  stopIndex: number,
  isHighLight?: boolean,
  timezone?: string,

  labels?: TripStopLabelStruct[]
) {
  {
    const statuses = stop.status;

    const start = dayjs(stop.actualArrivalDateTime);
    const end = dayjs(stop.actualDepartureDateTime);

    return {
      start,
      end,
      label: labels
        ? labels.find(
            (label) =>
              label.tripId === trip.tripId &&
              stop.tripStopId === label.tripStopId
          )?.label ?? `${stopIndex}`
        : `${stopIndex}`,
      colorIndex: trip.additionalData?.colorPaletteIndex ?? tripIndex,
      additionalInfo: {
        tripStopId: stop.tripStopId,
        tripIndex: tripIndex,
        name: stop.place?.name ? `${stop.place?.name}` : undefined,
        // companyName: stop.location.customer ? `${stop.location.customer.companyName ?? ''}` : undefined,
        // warehouseName: stop.location.warehouse ? `${stop.location.warehouse.name ?? ''}` : undefined,
        arrive: stop.plannedArrivalDateTime,
        departure: stop.plannedDepartureDateTime,
        status: stop.status,
        // timeWindowFrom: stopIndex > 0 ? stop.timeWindowFrom : null,
        // timeWindowTo: stopIndex > 0 ? stop.timeWindowTo : null,
        // timeWindowStatus:
        //   stopIndex > 0 ? getTimeWindowStatus(stop, trip.status, trip.startsAt, timezone, displayComputed) : 0,
        // timeWindowAlertReason: delayedMinutes > 0 ? ' - Due to late start' : '',
        // packagesStatus,
        // shipToAddressee: stop.shipToAddressee,
      },
      highlight: isHighLight,
      hidden: !stop.actualArrivalDateTime,
    };
  }
}

export function getLabelsOfTripStops(trips: TripResponse[]) {
  const labels: TripStopLabelStruct[] = [];
  trips.forEach((trip) => {
    trip.tripStops?.forEach((stop, stopIndex) => {
      labels.push({
        tripId: trip.tripId ?? 0,
        tripStopId: stop.tripStopId,
        label: stopIndex > 0 ? `${stopIndex}` : "W",
      });
    });
  });
  return labels;
}

export function getStopSequence(
  tripStops: TripStopResponse[],
  sortByComptedTimes?: boolean
) {
  const stopsSequence = tripStops
    .map((stop) => ({
      tripStopId: stop.tripStopId ? stop.tripStopId : stop.placeId,
      arrivalDate: sortByComptedTimes
        ? stop.actualArrivalDateTime
        : stop.plannedArrivalDateTime,
    }))
    .filter((stopInfo) => stopInfo.arrivalDate);
  stopsSequence.sort(
    (a: any, b: any) =>
      dayjs(a.arrivalDate).unix() - dayjs(b.arrivalDate).unix()
  );
  return stopsSequence;
}

export interface TripTimelineItem {
  arrival?: Date;
  departure?: Date;
  pathLength?: number;
  duration?: number;
  stopNumber?: number;
  info: {
    title: string;
    purpose: string;
    type: string;
    address?: string;
    orders?: OrderResponse[];
    dwellCost?: number;
    transitCost?: number;
    allocatedCost?: number;
    vehicleStopId?: number;
  };
  location: HasLatLong;
  focused?: boolean;
  ref?: any;
  id?: number;
}

export function getTripTimeline(
  trip: VehicleTripResponse,
  focusedStopId?: number
) {
  const timeline: TripTimelineItem[] = [];

  trip.vehicleStops?.forEach((stop, sIndex) => {
    timeline.push({
      arrival: stop.arrivedAt,
      departure: dayjs(stop.arrivedAt).add(stop.duration, "minutes").toDate(),
      pathLength: stop.pathLength,
      duration: stop.duration,
      // stopNumber: tripStopIndex >= 0 ? tripStopIndex : undefined,
      info: {
        purpose: stop.purpose ?? "UNKNOWN",
        title: "UNKNOWN",
        type: stop.type ?? "UNKNOWN",
        // address: stop. ?? 'UNKNOWN',
        dwellCost: stop.dwellCost ?? 0,
        transitCost: stop.transitShareCost ?? 0,
        // allocatedCost: stop.allocatedCost ?? 0,
        vehicleStopId: stop.vehicleStopId ?? 0,
      },
      location: {
        latitude: stop.latitude,
        longitude: stop.longitude,
      },
      focused: stop.vehicleStopId === focusedStopId,
      id: stop.vehicleStopId,
    });
  });

  return timeline;
}

export function getVehicleStopTypeAndColor(stop: VehicleStopResponse) {
  const c: DefaultMantineColor = "#888";
  const output = {
    type: convertConstantLiteralToNormal(stop.purpose as string),
    color: "#888",
    name: undefined as string | undefined,
  };
  if (stop.type === "UNRELATED") {
    switch (stop.purpose) {
      case "GENERAL":
        output.color = "#977";
        break;
      case "REST":
        output.color = "#7c7";
        break;
      default:
        output.color = "red";
        output.type = "Unknown";
    }
  } else {
    switch (stop.purpose) {
      case "PICKUP":
        output.color = "blue";
        break;
      case "DROP_OFF":
        output.color = "lime";
        break;
      default:
        output.color = "dark";
    }
  }
  if (stop.orders?.length) {
    const order = stop.orders.find((o) => o.customer);
    if (order) {
      output.name = order.customer.displayName;
    }
  }
  return output;
}
